export const fetchReportData = async (
  url: string,
  token: string,
  mapFunction: (item: any) => any,
  filterData: Record<string, any>
) => {
  try {
    const queryParams = new URLSearchParams(filterData).toString();
    const fullUrl = `${url}?${queryParams}`;

    const response = await fetch(fullUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.data.map(mapFunction);
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};
